import type { StateCreator, StoreApi, UseBoundStore } from 'zustand';

import type { RatingCallRequest } from '@ctct/domain-layer';

export interface IOrderSummarySlice {
  ratingPayload: RatingCallRequest | null;
  orderSummaryDisabled: boolean;
  taxUpdateRequested: boolean;
  isVatEuCountry: boolean;
  orderSummaryShowB2bNotification: boolean;
  isXeroAddonSelected?: boolean;
}

export const createOrderSummarySliceDefaultValues = (): IOrderSummarySlice => ({
  ratingPayload: null,
  orderSummaryDisabled: false,
  taxUpdateRequested: false,
  isVatEuCountry: false,
  orderSummaryShowB2bNotification: false,
  isXeroAddonSelected: false,
});

export const createOrderSummarySlice: StateCreator<IOrderSummarySlice> = () => createOrderSummarySliceDefaultValues();

export type OrderSummaryPageStore = UseBoundStore<StoreApi<IOrderSummarySlice>>;

export const createOrderSummaryHooks = (pageStore: OrderSummaryPageStore) => {
  return {
    useRatingCallPayload: () => pageStore((state) => state.ratingPayload),
    useDisabled: () => pageStore((state) => state.orderSummaryDisabled),
    useIsVatEuCountry: () => pageStore((state) => state.isVatEuCountry),
    useIsB2bNotificationVisible: () => pageStore((state) => state.orderSummaryShowB2bNotification),
    useIsXeroAddonSelected: () => pageStore((state) => state.isXeroAddonSelected),
  };
};

export type OrderSummaryHooks = ReturnType<typeof createOrderSummaryHooks>;
